import { MutableRefObject } from 'react';

export type BasicTarget<T = HTMLElement> =
  | (() => T | null)
  | T
  | null
  | MutableRefObject<T | null | undefined>;

type TargetElement = HTMLElement | Element | Document | Window;

export function getTargetElement(
  target?: BasicTarget<TargetElement>,
  defaultElement?: TargetElement,
): TargetElement | undefined | null {
  if (!target) {
    return defaultElement;
  }

  let targetElement: TargetElement | undefined | null;

  if (typeof target === 'function') {
    targetElement = target();
  } else if ('current' in target) {
    targetElement = target.current;
  } else {
    targetElement = target;
  }

  return targetElement;
}

/*
 * contenteditable, set caret at the end of the text
 * https://stackoverflow.com/questions/4233265/contenteditable-set-caret-at-the-end-of-the-text-cross-browser
 * */
export function placeCaretAtEnd(el?: HTMLElement | null) {
  if (!el) return;

  el.focus();
  if (typeof window.getSelection !== 'undefined'
            && typeof document.createRange !== 'undefined') {
    const range = document.createRange();
    range.selectNodeContents(el);
    range.collapse(false);
    const sel = window.getSelection();
    if (sel) {
      sel.removeAllRanges();
      sel.addRange(range);
    }
  }
}

/*
 * Viewport height is taller than the visible part of the document in some mobile browsers
 * https://bugs.webkit.org/show_bug.cgi?id=141832
 * */
export const fixVHUnit = () => {
  const handle = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };

  // initialize
  handle();

  window.addEventListener('resize', handle, false);
  window.addEventListener('orientationchange', () => {
    setTimeout(handle, 500);
  }, false);
};

/*
 * Outer Height With Margin
 * */
export const getOuterHeight = (el: HTMLElement) => {
  let height = el.offsetHeight;
  const style = getComputedStyle(el, null);

  height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
  return height;
};
